import { ref, UnwrapRef, watchEffect } from "vue";
import { useValidation } from "./useValidation";
import { useModel } from "./useModel";
import { validate, ValidationError } from "class-validator";

export function useForm<T extends object>(ModelClass: new () => T) {
  const { modelClass, clearModel: clearModelData, setModel } = useModel(ModelClass);

  const { errors, isValid, setError, clearErrors } = useValidation<T>();

  const isValidFlag = ref(false);

  const validateModel = async (): Promise<void> => {
    await validationForm(modelClass.value);
    isValidFlag.value = true;
  };

  const validationForm = async (modelValue: T): Promise<void> => {
    const result: ValidationError[] = await validate(modelValue);
    errors.value = setError(result) as UnwrapRef<typeof errors.value>;
  };

  watchEffect(async () => {
    if (isValidFlag.value) await validationForm(modelClass.value);
  });

  const clearModel = () => {
    clearModelData();
    clearErrors();
    isValidFlag.value = false;
  };

  const setModelData = (data: Partial<T>) => {
    setModel(data);
    clearErrors();
    isValidFlag.value = false;
  };

  return {
    modelClass,
    errors,
    clearErrors,
    clearModel,
    validateModel,
    isValid,
    setModelData,
  };
}
